import script from "./Activity_Goodkid2026Test.vue?vue&type=script&setup=true&lang=js"
export * from "./Activity_Goodkid2026Test.vue?vue&type=script&setup=true&lang=js"

import "./Activity_Goodkid2026Test.vue?vue&type=style&index=0&id=1f050192&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f050192"]])

export default __exports__